import Button, { ButtonProps } from "@mui/material/Button";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { useState } from "react";
import Menu from "@mui/material/Menu";
import { useStyles } from "./styles";

type MenuButtonProps = ButtonProps & {
  label: string | React.ReactNode;
  showArrow?: boolean;
  children: React.ReactElement<any, any> | React.ReactElement<any, any>[];
};

export function MenuButton({
  children,
  label,
  showArrow = true,
  ...rest
}: MenuButtonProps) {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        {...rest}
        endIcon={!Boolean(showArrow) ? null : <KeyboardArrowDown />}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {label}
      </Button>
      <Menu
        className={styles.root}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {children}
      </Menu>
    </>
  );
}
